import RadioButton from '@/components/RadioButton';
import { useEffect } from "react";
import PropTypes from 'prop-types';

const CellCommonRadioComponent = ({
    isReadOnly,
    schema,
    payload,
    parentProps,
    inputProps,
    setInputProps,
    updatePayload,
    validateSchema,
    getFieldValue,
}) => {

    const radioOptions = [
		{
			value: true,
			label: "Yes"
		},
		{
			value: false,
			label: "No"
		}
	]

    const options = () => {
        const arrayOptions = schema["x-uioptions"] ?? radioOptions;
        return arrayOptions.map((v, index) => {
            return { value: v.value, label: v.label, index: index }
        })
    }

    useEffect(() => {
        setInputProps({
            ...inputProps,
            disabled: isReadOnly,
            value: getFieldValue(payload, parentProps) === null ? "" : getFieldValue(payload, parentProps)
        });
    }, [payload]);

    function onClick(value, label) {
        if (isReadOnly) {
            return;
        }
        setInputProps({ ...inputProps, value, label });
        updatePayload(value);
        validateSchema(value);
    }

    return (
        <div className="eform-radio-container">
            {options().map(({ label, value, index }) => {
                return (<div className="flex-box flex-start flex-align-center" key={index}>
                    <RadioButton
                        name={label}
                        check={value === inputProps?.value}
                        value={value}
                        submit={() => onClick(value, label)}
                        disabled={isReadOnly}
                    />
                </div>)
            })}
        </div>
    );
};

CellCommonRadioComponent.propTypes = {
    isReadOnly: PropTypes.any,
    schema: PropTypes.any,
    payload: PropTypes.any,
    parentProps: PropTypes.any,
    inputProps: PropTypes.any,
    setInputProps: PropTypes.any,
    updatePayload: PropTypes.any,
    validateSchema: PropTypes.any,
    getFieldValue: PropTypes.any
};

export default CellCommonRadioComponent;
